import { render, staticRenderFns } from "./PasswordConfirm.vue?vue&type=template&id=0fdd4bea&scoped=true&"
import script from "./PasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./PasswordConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd4bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdd4bea')) {
      api.createRecord('0fdd4bea', component.options)
    } else {
      api.reload('0fdd4bea', component.options)
    }
    module.hot.accept("./PasswordConfirm.vue?vue&type=template&id=0fdd4bea&scoped=true&", function () {
      api.rerender('0fdd4bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/recursos/PasswordConfirm.vue"
export default component.exports